import {
  SnippetElement,
  defineElement,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-footer/common-footer.ts
var CommonFooter = class extends SnippetElement {
  handleOpenButtonClick(elm) {
    const index = parseInt(elm.dataset.openButton);
    if (this.accordions[index].isOpen) {
      this.close(index);
    } else {
      this.closeAll();
      this.open(index);
    }
  }
  open(index) {
    this.accordions[index].open();
    this.chevrons[index].classList.add("rotate-180");
  }
  close(index) {
    this.accordions[index].close();
    this.chevrons[index].classList.remove("rotate-180");
  }
  closeAll() {
    this.accordions.forEach((accordion, index) => {
      this.close(index);
    });
  }
  connectedCallback() {
    return __async(this, null, function* () {
      var _a;
      if (this.accordions.length !== 0) {
        this.open(0);
      }
      if (this.successModal) {
        const url = new URL(window.location.href);
        if (url.searchParams.get("customer_posted")) {
          (_a = this.successModal) == null ? void 0 : _a.open();
          url.searchParams.delete("customer_posted");
          window.history.replaceState({}, "", url);
        }
      }
    });
  }
};
__decorateClass([
  queryAll("[data-accordion]")
], CommonFooter.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-chevron]")
], CommonFooter.prototype, "chevrons", 2);
__decorateClass([
  query("[success-modal]")
], CommonFooter.prototype, "successModal", 2);
__decorateClass([
  onClick("[data-open-button]")
], CommonFooter.prototype, "handleOpenButtonClick", 1);
CommonFooter = __decorateClass([
  defineElement("common-footer")
], CommonFooter);
export {
  CommonFooter
};
